import { Typography } from "@mui/material";
import SnackbarMessage from "components/SnackbarMessage";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { useState } from "react";
import { FormattedMessage as T, useIntl } from "react-intl";
import {
  GenerateWebinarRequest,
  ResponseCode,
} from "services/KnowfullyAdminClient";
import { SnackbarMessageProps } from "types/common-types";
import translateError from "utils/translateError";
import TestDataGenerationForm, {
  WebinarFormValues,
} from "./TestDataGenerationForm";

const TestDataGenerationCreateForm = () => {
  const { formatMessage: t } = useIntl();
  const { testDataGenerationService } = useGlobalContext();
  const [
    snackbarMessage,
    setSnackbarMessage,
  ] = useState<SnackbarMessageProps | null>(null);

  useTitle(t({ id: "newTestWebinar" }));

  const onSubmit = async (values: WebinarFormValues) => {
    try {
      var response = await testDataGenerationService.generateWebinar(
        GenerateWebinarRequest.fromJS({ ...values })
      );

      if (response.responseCode === ResponseCode.OK) {
        setSnackbarMessage(
          new SnackbarMessageProps(t({ id: "webinarCreatedLabel" }))
        );
        return;
      }

      return { [FORM_ERROR]: translateError(response.responseReason, t) };
    } catch (err: any) {
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <Typography variant="h5">
        <T id="newTestWebinar" />
      </Typography>
      <TestDataGenerationForm
        onSubmit={onSubmit}
        submitLabel={t({ id: "createNew" })}
      />
      <SnackbarMessage
        snackbarMessage={snackbarMessage}
        setSnackbarMessage={setSnackbarMessage}
      />
    </>
  );
};

export default TestDataGenerationCreateForm;
